import FingerprintJS from '@fingerprintjs/fingerprintjs'

export const fetchFingerprint = async () => {
    const fpPromise = FingerprintJS.load()
    const fp = await fpPromise
    const { visitorId } = await fp.get()
    return visitorId
}
